import React from "react";
import styled from "styled-components";
import { motion, useReducedMotion } from "framer-motion";
import { ease } from "../tokens";
import { Inner, useReveal } from "../primitives";
import TradingCard from "../TradingCard";
import Marquee from "../Marquee";
import { ZIP_SECTION } from "../data";
import EraHeader from "./EraHeader";

const Wrap = styled.div`
  padding-bottom: clamp(120px, 22vh, 240px);
`;

const MarqueeBand = styled(Marquee)`
  margin-top: clamp(36px, 6vh, 72px);
`;

/* The card deals in over the marquee, overlapping it slightly. */
const CardWrap = styled.div`
  margin-top: clamp(-44px, -4vh, -24px);
  max-width: 460px;
  margin-left: auto;
  margin-right: auto;
  perspective: 1200px;
`;

const CAMPAIGNS = [
  "Amazon",
  "Kmart",
  "Service NSW",
  "Zip Pay",
  "Black Friday",
  "Contentful",
];

/** Section — 01 Zip Co (2018–2020): campaign marquee + a dealt-in card. */
const ZipSection: React.FC = () => {
  const reduced = useReducedMotion();
  const { ref, shown } = useReveal();
  return (
    <Wrap id="work" data-era={0}>
      <Inner>
        <EraHeader
          era={ZIP_SECTION}
          statementInk="Where it started — a fintech scale-up."
          statementMuted="Marketing pages alongside Amazon, Kmart and Service NSW, and a Contentful engine designers loved."
        />
      </Inner>
      <MarqueeBand items={CAMPAIGNS} duration={34} />
      <Inner>
        <CardWrap ref={ref}>
          <motion.div
            initial={false}
            animate={
              shown
                ? { opacity: 1, y: 0, rotate: -1.4, rotateY: 0 }
                : {
                    opacity: 0,
                    y: reduced ? 0 : 48,
                    rotate: reduced ? 0 : -7,
                    rotateY: reduced ? 0 : -55,
                  }
            }
            transition={{ duration: 1, ease: ease.out }}
            style={{ transformStyle: "preserve-3d" }}
          >
            <TradingCard card={ZIP_SECTION.cards[0]} />
          </motion.div>
        </CardWrap>
      </Inner>
    </Wrap>
  );
};

export default ZipSection;
